document.addEventListener('DOMContentLoaded', function () {
  //customer login desktop popup view
    const togglePassword = document.getElementById('togglePassword');
    const passwordInput = document.getElementById('inputPassword');   
    togglePassword.addEventListener('click', function () {
      const inputPassValue = document.getElementById('inputPassword').value;
      if(inputPassValue){
      const type = passwordInput.getAttribute('type') === 'password' ? 'text' : 'password';
      passwordInput.setAttribute('type', type);
      this.innerHTML = type === 'password' ? '<i class="fa fa-eye-slash" aria-hidden="true">' : '<i class="fa fa-eye" aria-hidden="true"></i>';
        }else{
        return;
      }
    });

//customer login mobile view
    const togglePasswordMobile = document.getElementById('togglePassword_mobile');
    const passwordInputMobile = document.getElementById('inputPassword_mobile');   
    togglePasswordMobile.addEventListener('click', function () {
      const inputPassValueMobile = document.getElementById('inputPassword_mobile').value;
      if(inputPassValueMobile){
      const type = passwordInputMobile.getAttribute('type') === 'password' ? 'text' : 'password';
      passwordInputMobile.setAttribute('type', type);
      this.innerHTML = type === 'password' ? '<i class="fa fa-eye-slash" aria-hidden="true">' : '<i class="fa fa-eye" aria-hidden="true"></i>';
        }else{
        return;
      }
    }); 


  //customer login mobile view
    const togglePasswordpageTemp = document.getElementById('togglePassword_pagetemp');
    const passwordInputpageTemp = document.getElementById('inputPassword_pagetemp');   
    togglePasswordpageTemp?.addEventListener('click', function () {
      const inputPassword_pagetemp = document.getElementById('inputPassword_pagetemp').value;
      if(inputPassword_pagetemp){
      const type = passwordInputpageTemp.getAttribute('type') === 'password' ? 'text' : 'password';
      passwordInputpageTemp.setAttribute('type', type);
      this.innerHTML = type === 'password' ? '<i class="fa fa-eye-slash" aria-hidden="true">' : '<i class="fa fa-eye" aria-hidden="true"></i>';
        }else{
        return;
      }
    });

// Register password view
 
    const togglePasswordButtons = document.querySelectorAll('.view_password');
    const passwordInputs = document.querySelectorAll('.password_input');
    togglePasswordButtons.forEach((button, index) => {
        button.addEventListener('click', function() {  
            const passwordInput = passwordInputs[index];
            const inputValue = passwordInput.value;

            if (inputValue) {
                const type = passwordInput.getAttribute('type') === 'password' ? 'text' : 'password';
                passwordInput.setAttribute('type', type);
                this.innerHTML = type === 'password' ? '<i class="fa fa-eye-slash" aria-hidden="true"></i>' : '<i class="fa fa-eye" aria-hidden="true"></i>';
            } else {
                return;
            }
        });
    });
 

  
});
 

$(document).ready(function(){
  $('.custom-slider-with-arrows').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: true,
        vertical: false,
        verticalSwiping: false,
        focusOnSelect: true,
        prevArrow: '<button type="button" class="slick-brand-prev fa fa-angle-left"></button>',
        nextArrow: '<button type="button" class="slick-brand-next fa fa-angle-right"></button>',

        responsive: [
          {
            breakpoint: 1200,
            settings: {
               slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 768,
            settings: {
               slidesToShow: 2,
             slidesToScroll: 1,
            }
          },

          {
            breakpoint: 574,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      });
});